// extracted by mini-css-extract-plugin
export var actions = "Hero-module--actions--B4i4t";
export var btn = "Hero-module--btn--Tl7-j";
export var inner = "Hero-module--inner--Ntq-c";
export var root = "Hero-module--root--BNP3k";
export var title = "Hero-module--title--fq6R5";